<template>
	<nk-page commercialAccess="System">
		<template v-if="isModal" #badges>
			<nk-badge system="accounting">
				<nk-badge-item type="system" modelValue="accounting"></nk-badge-item>
			</nk-badge>
		</template>

		<div class="overflow-auto h-100 d-flex flex-column form-container">
			<div class="nk-card">
				<div class="row">
					<div class="col-12" v-for="item, i in localData.filter(field => !settings.autoFields.includes(field.type))" :key="i">
						<nk-col-form-group :label="item.name + ':'" :labelSizes="{ sm: 2 }" :dataSizes="{ sm: 4 }">

							<div v-if="item.type === 'date'" class="row">
								<div class="col-10 pl-0">
									<nk-date :options="componentOptions.date" v-model="item.value"></nk-date>
								</div>
								<div class="col-2 pr-1">
									<nk-button class="button" :options="componentOptions.setTodayButton" @click="setToday(item)"></nk-button>
								</div>
							</div>

							<div v-else-if="item.type === 'guid'" class="row">
								<div class="col-12">
									<nk-radio class="ml-1" v-model="item.value" :group="item.name" :options="{ title: $t('current-company'), value: 'currentCompany', style: 'padding-top:3px' }" />
								</div>
								<div class="col-12">
									<nk-radio class="ml-1" v-model="item.value" :group="item.name" :options="{ title: $t('current-fiscal'), value: 'currentFiscal', style: 'padding-top:3px' }" />
								</div>
							</div>

							<div v-else-if="item.type === 'enum'">
								<nk-dropdown :data="enumsContainer[item.enum]" :options="componentOptions.enumDropdown" v-model="item.value" />
							</div>

							<div v-else-if="item.type === 'currentDate'">
								<nk-date :options="componentOptions.currentDate" :disabled="true" v-model="item.value"></nk-date>
							</div>

							<div v-else-if="item.type === 'smartDate'">
								<nk-date :disabled="true" :modelValue="getSmartDate(item.smartDate)"></nk-date>
							</div>

							<nk-input v-else v-model="item.value" :options="item.type === 'number' ? componentOptions.numberInput : componentOptions.stringInput"></nk-input>

						</nk-col-form-group>
					</div>
				</div>
			</div>
		</div>

	</nk-page>
</template>

<script>
	import { mapGetters } from 'vuex'
	import $sc from '~/plugins/shortcut.collection.js'
	import _ from 'lodash'
	import Endpoints from '@nikan/endpoints'
	import { post } from '@/plugins/nikan-api'
	import dynamicReportInstance from '@/plugins/dynamic-report'

	export default {
		name: 'report-parameters',
		modal: {
			size: 'sm',
			stateUID: 'report-parameters',
		},
		props: {
			data: { type: Array },
			options: { type: Object },
			isModal: {
				default: true,
				type: Boolean
			}
		},
		emits: ['update:data'],
		data() {
			return {
				localData: [],
				enumsContainer: {},
				settings: {
					autoFields: []
				},
				componentOptions: {
					currentDate: {
						defaultValue: 'now',
					},
					date: {
						pickerEnabled: true,
						pickerCss: 'btn btn-default',
					},
					numberInput: {
						mode: 'strnumber',
					},
					stringInput: {
						mode: 'string',
					},
					setTodayButton: {
						hideTitle: true,
						isOutline: true,
						icon: 'calendar-day'
					},
					enumDropdown: {
						searchable: true,
						remoteSearch: false,
						placeholder: this.$t('select-it'),
						display: function (item) {
							return item.translate
						},
						searchableFields: ['key'],
						targetField: 'key'
					}
				},

				saveButton: {
					title: this.$t('dynamic-report.continue'),
					shortcut: $sc.find('save'),
					isPrimary: false,
					disabled: false,
					icon: 'arrow-right',
					handle: () => {
						this.resolveData()
					},
				}

			}
		},
		watch: {
			localData: {
				immediate: true,
				deep: true,
				handler(newVal, oldVal) {
					this.$emit('update:data', this.localData)
				}
			}
		},
		computed: {
			...mapGetters({
				currentCompany: 'appContext/getCompany',
				currentFiscal: 'appContext/getFiscalPeriod'
			})
		},
		mounted() {
			this.settings = _.merge(this.options, this.settings)
			this.prepareWindow(this.$t('forms.ReportParameters'), [this.saveButton])
			this.localData = _.cloneDeep(this.data)
			this.prepareEnumItems()
		},
		methods: {
			prepareEnumItems() {
				let enumTypes = []
				for (let parameter of this.localData) {
					if (parameter.enum) {
						enumTypes.push(parameter.enum)
					}
				}


				if (enumTypes.length > 0) {
					post(Endpoints.getUrl('entityStructure.getEnumItems'), { types: enumTypes }).then(res => {
						res.data.items.forEach(item => {
							const allEnumItems = item.enumItems.map(enumItem => {
								enumItem.translate = this.$t(`enum-items.${item.type.split('_')[1]}.${enumItem.value}`)
								return enumItem
							})

							this.enumsContainer[item.type] = allEnumItems
						})
					})
				}
			},
			resolveData() {
				if (this.validateInputs()) {
					this.resolve(this.localData)
				}
			},
			setToday(item) {
				var date = new Date()
				// var date = new PersianDate().format('YYYY/MM/DD')
				item.value = date
			},
			getSmartDate(smartDate) {
				return dynamicReportInstance.calculateSmartDate(smartDate)
			},
			validateInputs() {
				let errors = []

				for (let item of this.localData) {
					if (item.isRequired && _.isEmpty(item.value) && !this.settings.autoFields.includes(item.type))
						errors.push({
							key: '',
							error: this.$t('msg.required', [item.name])
						})
				}

				this.validationToast(errors)
				return errors.length === 0
			}
		},


	}
</script>

<style></style>
